export const FETCH_DATA_REQUEST_REVIEW = "FETCH_DATA_REQUEST_REVIEW";
export const FETCH_DATA_SUCCESS_REVIEW = "FETCH_DATA_SUCCESS_REVIEW";
export const FETCH_DATA_FAILURE_REVIEW = "FETCH_DATA_FAILURE_REVIEW";

